import React from 'react'

import ListPageHeader from '@shared/ListPageHeader'
import ImportsList from '@shared/imports/ImportsList'

import { importService } from '@services/admin/importService'

export default function AdminImportsList() {
  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['data', 'imports']}
      />
      <ImportsList
        role="admin"
        service={importService}
      />
    </div>
  )
}
